import { render } from "./RutasCobrosList.vue?vue&type=template&id=7e30ba4c"
import script from "./RutasCobrosList.vue?vue&type=script&lang=js"
export * from "./RutasCobrosList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wServer\\app-pagos-elroble\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__